import { ImportReferenceEditForm } from 'application/import-reference/forms';
import {BaseEditViewStore, BaasicDropdownStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {ImportReferenceService} from 'application/import-reference/services';
import { InsuranceService } from 'application/import-reference/services';
import { ImportReferenceTypeService } from 'application/import-reference-type/services';
import { action } from 'mobx';

@applicationContext
class ImportReferenceEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ImportReferenceService(rootStore.application.baasic.apiClient);
        const insuranceService = new InsuranceService(rootStore.application.baasic.apiClient);
        const importReferenceTypeService = new ImportReferenceTypeService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'role',
            id: id,
            Form: ImportReferenceEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {     
                        const response = await service.get(id, {
                            ...opts,
                            embed: "Insurance" } );    
                        this.insuranceStore.setValue(response.data.insurance);                    
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ImportReferenceEditForm,
        });

        this.insuranceStore = new BaasicDropdownStore({
			filterable: true,
		}, {
			fetchFunc: async(term) => {
				const response = await insuranceService.find({
					searchQuery: term,
					rpp: 125,
                    sort: 'name|asc'
			});
                return response.data.item;
			}
		});

        this.importReferenceTypeStore = new BaasicDropdownStore({
			filterable: true,
		}, {
			fetchFunc: async(term) => {
				const response = await importReferenceTypeService.find({
					searchQuery: term,
					rpp: 25,
                    sort: 'name|asc'
			});
                return response.data.item;
			}
		});
    } 
    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE.CREATE.SUCCESS_CREATE');
    }
    
    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE.EDIT.SUCCESS_UPDATE', name);
    }
}

export default ImportReferenceEditViewStore;
